export let environmentTypes = ['Seco', 'Refrigerado', 'Congelado'];